
/* APPLICATION ROUTE CONSTANTS */
module.exports = Object.freeze({
  
    ROW_PER_PAGE : [10, 50, 100, 300, 500],

    // Status
    STATUS_REGISTER:'Register',

    /* Routers Link supplier_app */
    APP_HOME: '/applications',
    HOME: '/home',
    
    HOME_INTRO:'/logistics-intro',
    DASHBOARD: '/logistics-dashboard',
    INBOX: '/logistics-inbox',
    OUTBOX: '/logistics-outbox',

   /* Master */
   LOGISTICS_MASTER_VEHICLE_CREATE: '/vehicle-creation',
   LOGISTICS_MASTER_VEHICLE_LIST: '/vehicle-list',
   LOGISTICS_MASTER_VEHICLE_DETAILS: '/vehicle-details',

   /* Master */
   LOGISTICS_MASTER_DRIVER_CREATE: '/driver-creation',
   LOGISTICS_MASTER_DRIVER_LIST: '/driver-list',
//    LOGISTICS_MASTER_DRIVER_DETAILS: '/driver-details',
   LOGISTICS_MASTER_DRIVER_DETAILS: '/driver-details',

   /* tansporter */
   LOGISTICS_TRANSPORT_REQUEST_CREATE:'/transport-request-creation',
   LOGISTICS_TRANSPORT_REQUEST_LIST_INT:'/transport-request-list-intransit',
   LOGISTICS_TRANSPORT_REQUEST_LIST_ACK:'/transport-request-list-delivered',
   LOGISTICS_TRANSPORT_REQUEST_DETAILS:'/transport-request-details',
   LOGISTICS_PAYMENT_LIST:'/dirver-payment-list',

   /* Master/Transporter */
   LOGISTICS_MASTER_TRANSPORTER_REGISTRATION: '/transporter-registration',
   LOGISTICS_MASTER_TRANSPORTER_LIST: '/transporter-list',
   LOGISTICS_MASTER_TRANSPORTER_DETAILS: '/transporter-details',

   //gate Entery
   LOGISTICS_IN_WORD_OUT_WORD_LIST: "/logistics-inward-outward-list",
   LOGISTICS_GATE_ENTRY_UPDATE: "/logistics-gate-details",

   //fuel Entry
   LOGISTICS_FUEL_ENTRY_LIST:"/logistics-fuel-entry-list",
   LOGISTICS_FUEL_ENTRY_CREATE:"/logistics-fuel-entry-create",

   //Bunk 
   LOGISTICS_MASTER_BUNK_CREATE: '/bunk-creation',
   LOGISTICS_MASTER_BUNK_LIST: '/bunk-list',
   LOGISTICS_MASTER_BUNK_DETAILS: '/bunk-details',
   
   //Bank
   LOGISTICS_BANK_LIST:'/bank-list',
   LOGISTICS_GOWDOWN_LIST:'/godown-list',
   LOGISTICS_GOWDOWN_CREATE:'/godown-creation',
   LOGISTICS_GOWDOWN_DETAILS:'/godown-details',


})  

